import { ComputeVehicleCategoryDepositParams } from '../interfaces/compute-vehicle-category-deposit-params.interface';

import { applyPercentageDepositRounding } from '../../../functions/apply-percentage-deposit-rounding.function';
import { toRoundedAmount } from '../../../functions/to-rounded-amount.function';

/**
 * Computes the vehicle-category deposit from a flat rate, else a percentage of
 * the discounted standard gross. Returns 0 when no deposit is configured.
 * Percentage-derived amounts honor `percentageDepositRounding`; flat rates do not.
 * The gross fallback used for payment charging lives in resolveReservationPaymentAmount.
 */
export function computeVehicleCategoryDeposit(
  params: ComputeVehicleCategoryDepositParams,
): number {
  const {
    depositFlatRate,
    depositPercentage,
    discountedStandardGross,
    percentageDepositRounding,
  } = params;

  const flat = Number(depositFlatRate ?? 0);
  if (flat > 0) {
    return toRoundedAmount(flat);
  }

  const pct = Number(depositPercentage ?? 0);
  if (pct > 0) {
    const raw = discountedStandardGross * (pct / 100);
    return toRoundedAmount(
      applyPercentageDepositRounding(raw, percentageDepositRounding),
    );
  }

  return 0;
}
